import { _ } from "libs";

import React from "react";
import SportSelector from "./sportSelector";
import { Profile, Sport } from "../../types";

type Props = {
	profile: Profile;
	sports: Sport[];
	onChange: Function;
};

export function Step3({ profile, sports, onChange }: Props) {
	return (
		<div className="box onboardingStep3">
			<div className="boxLeader">
				<h2>{_("onboarding.favouriteSportSection.heading")}</h2>
				<div className="illustration player_serve" />
			</div>
			<div className="boxContent">
				<p>{_("onboarding.favoriteSportSection.content")}</p>
				<SportSelector profile={profile} sports={sports} onChange={onChange} />
			</div>
		</div>
	);
}

export default Step3;
